import { configureStore } from "@reduxjs/toolkit";
import jobs from "./slices/jobsSlice";
import countries from "./slices/countriesSlice";
import settings from "./slices/settingsSlice";
import news from "./slices/newsSlice";
import partners from "./slices/partnersSlice";
import certificates from "./slices/certificatesSlice";
import projects from "./slices/projectsSlice";
import branches from "./slices/branchesSlice";

const store = configureStore({
  reducer: {
    jobs,
    countries,
    settings,
    news,
    partners,
    certificates,
    projects,
    branches
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
